import { useCalendarService } from '@mews-commander/ui';
import { StructuredDate } from '@optimus-web/core';

export const TrialBalanceDate = ({ date }: { date: StructuredDate }) => {
    const calendarService = useCalendarService();
    return <>{calendarService.getDateString(date)}</>;
};
